// Recovered compiled webpack factory 32246. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { I: () => n });
  function n(t) {
    return t.replace(/([A-Z])/g, (t) => `-${t.toLowerCase()}`);
  }
}
